var _errorCodeToErrorClas;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Copyright (c) 2020-2022 Estonian Information System Authority
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import ActionPendingError from "../errors/ActionPendingError";
import ActionTimeoutError from "../errors/ActionTimeoutError";
import ContextInsecureError from "../errors/ContextInsecureError";
import ErrorCode from "../errors/ErrorCode";
import ExtensionUnavailableError from "../errors/ExtensionUnavailableError";
import NativeFatalError from "../errors/NativeFatalError";
import NativeInvalidArgumentError from "../errors/NativeInvalidArgumentError";
import NativeUnavailableError from "../errors/NativeUnavailableError";
import UnknownError from "../errors/UnknownError";
import UserCancelledError from "../errors/UserCancelledError";
import UserTimeoutError from "../errors/UserTimeoutError";
import VersionInvalidError from "../errors/VersionInvalidError";
import VersionMismatchError from "../errors/VersionMismatchError";
var errorCodeToErrorClass = (_errorCodeToErrorClas = {}, _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_ACTION_PENDING, ActionPendingError), _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_ACTION_TIMEOUT, ActionTimeoutError), _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_CONTEXT_INSECURE, ContextInsecureError), _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_EXTENSION_UNAVAILABLE, ExtensionUnavailableError), _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_NATIVE_INVALID_ARGUMENT, NativeInvalidArgumentError), _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_NATIVE_FATAL, NativeFatalError), _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_NATIVE_UNAVAILABLE, NativeUnavailableError), _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_USER_CANCELLED, UserCancelledError), _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_USER_TIMEOUT, UserTimeoutError), _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_VERSION_INVALID, VersionInvalidError), _defineProperty(_errorCodeToErrorClas, ErrorCode.ERR_WEBEID_VERSION_MISMATCH, VersionMismatchError), _errorCodeToErrorClas);
export function serializeError(error) {
  var message = error.message,
      name = error.name,
      fileName = error.fileName,
      lineNumber = error.lineNumber,
      columnNumber = error.columnNumber,
      stack = error.stack;
  return _objectSpread(_objectSpread({}, Object.fromEntries(Object.getOwnPropertyNames(error).map(function (prop) {
    return [prop, error[prop]];
  }))), {}, {
    message: message,
    name: name,
    fileName: fileName,
    lineNumber: lineNumber,
    columnNumber: columnNumber,
    stack: stack
  });
}
export function deserializeError(errorObject) {
  var error;

  if (typeof errorObject.code == "string" && errorObject.code in errorCodeToErrorClass) {
    var CustomError = errorCodeToErrorClass[errorObject.code];
    error = new CustomError();
  } else {
    error = new UnknownError();
  }

  for (var _i2 = 0, _Object$entries = Object.entries(errorObject); _i2 < _Object$entries.length; _i2++) {
    var _ref3 = _Object$entries[_i2];

    var _ref2 = _slicedToArray(_ref3, 2);

    var key = _ref2[0];
    var value = _ref2[1];
    error[key] = value;
  }

  return error;
}